import Commons from '../../../../Services/Common/Common';

/**
 * TB_BS_CODE.CODE 는 DB에 `CD_` + 본문 형태로 저장.
 * GetCodBasicR1 은 `SUBSTRING(tbc.CODE, 4) AS Code` 로 조회 시 이미 접두 3글자를 뺀 값을 줌.
 * Save/Delete 는 `CONCAT('CD_', @Code)` 전제이므로 그리드·API 본문의 Code 는 항상 접두 없는 본문만 쓰면 됨.
 * strip 은 사용자가 셀에 `CD_` 를 직접 넣은 경우 등 예외 정리용(정상 R1 응답에는 사실상 no-op).
 */
export const stripCodBasicCodeForApi = (value) => {
  const s = String(value ?? '').trim();
  return /^CD_/i.test(s) ? s.slice(3) : s;
};

/**
 * 그리드/API 필드 camelCase. SaveCodBasicU1 본문은 PascalCase 키 + 암호화 문자열.
 */
export const COD_BASIC_Schema = {
  fields: {
    groupCd: { initial: '', label: '그룹코드', required: 'Y' },
    code: { initial: '', label: '코드', required: 'Y' },
    codeNm: { initial: '', label: '코드명', required: 'Y' },
    val1: { initial: '', label: '값1' },
    val2: { initial: '', label: '값2' },
    val3: { initial: '', label: '값3' },
    ref1: { initial: '', label: '참조1' },
    ref2: { initial: '', label: '참조2' },
    ref3: { initial: '', label: '참조3' },
  },
  mapper: {
    search1: {
      Params: (_, context) =>
        Commons.EncryptAES(String(context.params ?? '').trim()) || '',
    },
    save1: {
      UserId: (_, context) => context.userInfo?.userid || '',
      GroupCd: (row) =>
        Commons.EncryptAES(row.groupCd ?? row.GroupCd ?? '') || '',
      Code: (row) =>
        Commons.EncryptAES(
          stripCodBasicCodeForApi(row.code ?? row.Code ?? '')
        ) || '',
      CodeNm: (row) =>
        Commons.EncryptAES(row.codeNm ?? row.CodeNm ?? '') || '',
      Val1: (row) => Commons.EncryptAES(row.val1 ?? row.Val1 ?? '') || '',
      Val2: (row) => Commons.EncryptAES(row.val2 ?? row.Val2 ?? '') || '',
      Val3: (row) => Commons.EncryptAES(row.val3 ?? row.Val3 ?? '') || '',
      Ref1: (row) => Commons.EncryptAES(row.ref1 ?? row.Ref1 ?? '') || '',
      Ref2: (row) => Commons.EncryptAES(row.ref2 ?? row.Ref2 ?? '') || '',
      Ref3: (row) => Commons.EncryptAES(row.ref3 ?? row.Ref3 ?? '') || '',
    },
    delete1: {
      GroupCd: (row) =>
        Commons.EncryptAES(row.groupCd ?? row.GroupCd ?? '') || '',
      Code: (row) =>
        Commons.EncryptAES(
          stripCodBasicCodeForApi(row.code ?? row.Code ?? '')
        ) || '',
    },
  },
};
